// Forward journey action types
export const APPLY_SYF_START = 'APPLY_SYF_START';
export const APPLY_SYF_START_SUCCESS = 'APPLY_SYF_START_SUCCESS';
export const APPLY_SYF_START_ERROR = 'APPLY_SYF_START_ERROR';

// Reverse journey action types
export const DECRYPT_SYF_RESULT_START = 'DECRYPT_SYF_RESULT_START';
export const DECRYPT_SYF_RESULT_SUCCESS = 'DECRYPT_SYF_RESULT_SUCCESS';
export const DECRYPT_SYF_RESULT_ERROR = 'DECRYPT_SYF_RESULT_ERROR';

// redirection
export const SYF_APPLICATION_GOTO_REFERRER = 'SYF_APPLICATION_GOTO_REFERRER';
export const SYF_APPLICATION_GOTO_WALLET = 'SYF_APPLICATION_GOTO_WALLET';

// adding to wallet
export const SYF_APPLICATION_WALLET_ADD = 'SYF_APPLICATION_WALLET_ADD';
export const SYF_APPLICATION_WALLET_ADD_LOADING = 'SYF_APPLICATION_WALLET_ADD_LOADING';
export const SYF_APPLICATION_WALLET_ADD_SUCCESS = 'SYF_APPLICATION_WALLET_ADD_SUCCESS';
export const SYF_APPLICATION_WALLET_ADD_ERROR = 'SYF_APPLICATION_WALLET_ADD_ERROR';

// Analytics action types
export const TRACK_SYF_VANITY_PAGE_LOAD = 'TRACK_SYF_VANITY_PAGE_LOAD';
export const TRACK_SYF_APPLICATION_APPROVED = 'TRACK_SYF_APPLICATION_APPROVED';
export const TRACK_SYF_APPLICATION_DECLINED = 'TRACK_SYF_APPLICATION_DECLINED';
export const TRACK_SYF_APPLICATION_APPROVED_ADDED_WALLET =
    'TRACK_SYF_APPLICATION_APPROVED_ADDED_WALLET';

export const TRACK_SYF_APPLICATION_ADDED_WALLET = 'TRACK_SYF_APPLICATION_ADDED_WALLET';
